import { render, staticRenderFns } from "./ReviewsDoNotSend.vue?vue&type=template&id=ccd385e4&scoped=true"
import script from "./ReviewsDoNotSend.vue?vue&type=script&lang=js"
export * from "./ReviewsDoNotSend.vue?vue&type=script&lang=js"
import style0 from "./ReviewsDoNotSend.vue?vue&type=style&index=0&id=ccd385e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd385e4",
  null
  
)

export default component.exports